// @flow

import styled from 'styled-components';

export const SelectOption = styled.option``;
